// İSG uzmanı portalı — Güvenlik / Saha Geçişi (Security Entry) TanStack Query anahtarları
// (api-contract §29, tenant-scoped). Ayarlar (§10) / Ziyaretçi (§11) anahtarlarıyla aynı desen;
// iş modülü olarak AYRIDIR.
//
// `gateResult` anahtarı `qrToken`'a göredir (jeton başına ayrı önbellek girdisi) — dönme
// yarışında eski+yeni jetonun AYNI ANDA yoklanması (bkz. `useGateCode.ts`) böylece birbirinin
// önbelleğini EZMEZ.

export const securityKeys = {
  /** Erişim sondası (`useSecurityAccess`) + saha seçici — PAYLAŞILIR (tek istek). */
  sites: () => ['security', 'sites'] as const,
  /** Kapı kodu yoklaması — jeton başına (dönme turunda eski+yeni birlikte yoklanır). */
  gateResult: (qrToken: string) => ['security', 'gate-result', qrToken] as const,
  /** TÜM günlük geçiş listelerinin öneki (her saha/tarih/`result`) — satırlar personel adını
   *  canlı çözer (§29.5), bir personel ad düzenlemesi (`personnelClient.ts`) hepsini tazeler. */
  entriesAll: () => ['security', 'entries'] as const,
  /** Günlük geçiş listesi ÖN EK'i (saha + tarih) — `result` süzgecinden BAĞIMSIZ, yeni bir
   *  okutma/TC sonucu geldiğinde `entries()`'in TÜM `result` varyantlarını (bugün yalnız `all`,
   *  yarın belki `allowed`) TEK çağrıda geçersiz kılmak için (TanStack'in varsayılan ön ek
   *  eşleşmesi — `exact` verilmedi). */
  entriesForDate: (siteUuid: string, date: string) =>
    ['security', 'entries', siteUuid, date] as const,
  /** Günlük geçiş listesi — saha + tarih + `result` süzgeci (istek girdisi — `result=allowed`
   *  isteyen bir arayan `result=all` önbelleğini SERVİS EDİLMİŞ bulmasın diye anahtarda). */
  entries: (siteUuid: string, date: string, result: string) =>
    [...securityKeys.entriesForDate(siteUuid, date), result] as const,
  /** Satır detayı (`GET /security/entries/{uuid}`, S32d) — `uuid` başına. Yanıt CANLI bir yarı
   *  taşır (`liveAsOf`) ve sözleşme önbelleğe alınmamasını ister (§29.5) — çağıran taraf
   *  (`EntryDetailModal.tsx`) `staleTime`/`gcTime`'ı `0`'a sabitler, anahtarın kendisi yalnız
   *  aynı `uuid`'in eşzamanlı iki gözlemcisini (varsayımsal — bu uçta yok) TEKİLLEŞTİRİR. Gün
   *  listesinin geçersiz kılınması bu anahtarı ETKİLEMEZ (satır hiç değişmez — §29.5, "log
   *  yalnız eklenir"); ikisi bağımsız okumalardır.
   */
  entryDetail: (uuid: string) => ['security', 'entry-detail', uuid] as const,
} as const;
